import { LanguagesEnum } from '../../../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  footer_part1: {
    [LanguagesEnum.English]: 'Total VAT Amount for ',
    [LanguagesEnum.Greek]: 'Total VAT Amount for ',
  },
  footer_part2: {
    [LanguagesEnum.English]: ' supplied from Fixed Establishments (€): ',
    [LanguagesEnum.Greek]: ' supplied from Fixed Establishments (€): ',
  },
};

export default CONFIGURATION;
